import { CEPlanWorkAssociationBase } from './ce-plan-work-association-base'


export class CEPlanWorkAssociation extends CEPlanWorkAssociationBase {

}